import React from "react";
import { Grid, Row, Col } from "@vds/grids";
import { Body } from "@vds/typography";
import { Tooltip } from "@mui/material";
import "./search.css";
import LazyImage from "./LazyImage";
import { FOV_IMAGE } from "./SearchConstants";

const SnapshotGrid = ({ fovListIdsToDisplayGroupBySites, siteReducerSites, deviceListItem }) => {
    if (!fovListIdsToDisplayGroupBySites || !siteReducerSites) return null;
    return (
        <div className="gridParentContainer">
            {Object.keys(fovListIdsToDisplayGroupBySites).map((fovSiteId) => (
                <React.Fragment key={fovSiteId}>
                    <Body viewport="desktop" size="large">{siteReducerSites.sites?.find(f => f.id === fovSiteId)?.name}</Body>
                    <Grid bleed="full" rowGutter="20px" colSizes={{ mobile: 1, tablet: 2, desktop: 3 }}>
                        <Row className="rowStyle">
                            {fovListIdsToDisplayGroupBySites[fovSiteId] && fovListIdsToDisplayGroupBySites[fovSiteId].map(fov => {
                               
                                return (
                                    <Col key={fov.id}>
                                        
                                        <LazyImage steamId={fov.id} imageFor={FOV_IMAGE} />
                                        <Body viewport='desktop' size='small'><b>Camera:</b> {deviceListItem.cameraList.find(f => f.id === fov.parentdeviceid).name}</Body>
                                        <div className="hs-thumb-stream-body">
                                            <strong className="hs-thumb-stream-label">Stream:</strong>
                                            <Tooltip title={fov.name || ""} placement="top-start" arrow disableHoverListener={!fov.name}>
                                                <span className="hs-thumb-stream-name">{fov.name}</span>
                                            </Tooltip>
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Grid>
                </React.Fragment>
            ))}
        </div>
    );
};

export default SnapshotGrid;
